var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-container',[_c('TreeTable',_vm._b({ref:"child",scopedSlots:_vm._u([{key:"searchSlot",fn:function(ref){
var query = ref.query;
return [_vm._t("searchSlot",null,{"query":query})]}}],null,true)},'TreeTable',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }